const isSSRTheme = () => {
  if (typeof window === 'undefined') {
    return process.env.REACT_APP_SERVE_MODE === 'SSR';
  }
  return document.body.getAttribute('theme') === 'SSR';
};

export default isSSRTheme;
